import { AlertCircle } from 'lucide-react';
import React from 'react';

export const WarningBanner = (props: {
  /** Plain text, or JSX when part of the message needs emphasis. */
  message: React.ReactNode;
  showIcon?: boolean;
  /**
   * Optional secondary content under the message, for a banner that needs a
   * supporting detail line as well as the headline (#10668). Existing
   * single-message callers render exactly as before.
   */
  children?: React.ReactNode;
}) => {
  // A single-line banner centres on its icon; once the message wraps or a
  // second line is supplied, a centred icon floats away from the text it
  // belongs to, so it aligns to the first line instead.
  const alignment = props.children ? 'items-start' : 'items-center';

  return (
    <div className="flex-none py-4">
      <div
        className={`flex ${alignment} gap-2 rounded-lg bg-amber-50 p-4 text-amber-800`}
      >
        {props.showIcon && <AlertCircle className="size-5 shrink-0" />}
        <div>
          <span>{props.message}</span>
          {props.children}
        </div>
      </div>
    </div>
  );
};
